import { afterNextRender, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScreenSizeStore {
  isMobileSize = signal<boolean>(false);

  constructor() {
    afterNextRender(() => {
      this.checkScreenSize();
      window.addEventListener('resize', this.checkScreenSize.bind(this));
    });
  }

  private checkScreenSize() {
    this.isMobileSize.set(window.innerWidth <= 768);
  }
}
